import React, { useEffect, useState } from 'react'
import SanitizeHtml from '../../Base/SanitizeHtml/SanitizeHtml'
import constants from '../../../../js/lib/constants'
import * as lib from '../../../../js/lib/lib'

const SidebarCosts = ({
  step,
  selectedVehicle,
  isPrepaid: isPrepaidStore,
  mbData,
  modifiedPrices,
  handleEditExtras,
  type,
  milesNBonusAccount,
}) => {
  const isBooking = window.bookingData ? true : false
  const { dictionary } = isBooking ? window.bookingData : window.modifyData
  const pageNumber = constants.booking.pageNumber
  const modifyPageNumber = constants.modify.pageNumber
  const lang = document.documentElement.lang || 'en'

  const [hasGrandTotal, setHasGrandTotal] = useState(false)

  const { prepaidPrice, returnPrice } = selectedVehicle?.car || {}

  const isPrepaid = () => {
    if (isPrepaidStore) {
      return prepaidPrice || {}
    }
    return returnPrice || {}
  }

  useEffect(() => {
    if (!isPrepaid()) {
      return
    }
    if (isPrepaid().prepaidCharge && isPrepaid().returnCharge) {
      setHasGrandTotal(true)
    } else {
      setHasGrandTotal(false)
    }
  }, [prepaidPrice, returnPrice])

  const selectedExtrasPrepaid = () => {
    if (!isPrepaid()) {
      return
    }
    const prices = isPrepaid()
    return prices.amenities.filter((amenity) => {
      return amenity.isPrepaid && amenity.requestedQuantity > 0
    })
  }

  const selectedExtrasReturn = () => {
    if (!isPrepaid()) {
      return
    }
    const prices = isPrepaid()

    if (isPrepaidStore) {
      return prices.amenities.filter((amenity) => {
        return !amenity.isPrepaid && amenity.requestedQuantity > 0
      })
    }
    return prices.amenities.filter((amenity) => {
      return amenity.requestedQuantity > 0
    })
  }

  const modificationPrices = [
    {
      name: dictionary.initialPaymentWithCard,
      quantity: modifiedPrices?.initialPaymentWithCard,
    },
    modifiedPrices?.initialPaymentWithMiles && {
      name: dictionary.initialPaymentWithMiles,
      quantity: modifiedPrices.initialPaymentWithMiles,
    },
    modifiedPrices?.newAmountPaidWithMiles && {
      name: dictionary.newAmountPaidWithMiles,
      quantity: modifiedPrices.newAmountPaidWithMiles,
    },
    modifiedPrices?.restToBePaidWithCard && {
      name: dictionary.restToBePaidWithCard,
      quantity: modifiedPrices.restToBePaidWithCard,
    },
    modifiedPrices?.refund && {
      name: dictionary.refundLabel,
      quantity: modifiedPrices.refund,
    },
  ].filter((item) => item)

  const milesReedemed = () => {
    return lib.formatCurrency(
      isPrepaid().prepaidCurrency,
      mbData?.redeemAmount / milesNBonusAccount?.rate
    )
  }

  const showMilesNBonusReedeemStatus = () => {
    const redeemEnabled = mbData?.redeemEnabled
    if (redeemEnabled && type === 'booking' && step === pageNumber.extras) {
      return false
    } else if (
      redeemEnabled &&
      type === 'modify' &&
      (step === modifyPageNumber.modifyCancel ||
        step === modifyPageNumber.pendingPayment)
    ) {
      return false
    }
    return redeemEnabled
  }

  // Convert redeemed miles to price
  const redeemedMilesToPrice = () => {
    if (
      !mbData?.redeemEnabled ||
      !mbData?.redeemAmount ||
      !milesNBonusAccount?.rate
    ) {
      return 0
    }
    // Convert miles to currency using the rate from mbData
    return mbData.redeemAmount / milesNBonusAccount.rate
  }

  // Calculate remaining amount to be paid with card after miles redemption
  const remainingCardPayment = () => {
    if (!modifiedPrices?.restToBePaidWithCard) {
      return 0
    }
    const restToPay = modifiedPrices.restToBePaidWithCard
    const milesInCurrency = redeemedMilesToPrice() || 0
    return restToPay - milesInCurrency
  }

  return (
    <>
      {/* Pay online */}
      {!!isPrepaid()?.prepaidCharge && (
        <div className="b-booking-sidebar__billing">
          <div className="b-booking-sidebar__billing__breakdown">
            <div className="b-booking-sidebar__breakdown__title">
              {dictionary.asidePayOnline}
            </div>
            <div className="b-booking-sidebar__breakdown__list">
              <div className="b-booking-sidebar__breakdown__item">
                <span className="b-booking-sidebar__breakdown__item__label">
                  {dictionary.asideCarRentalLabel} {'x'}{' '}
                  {selectedVehicle.duration} {dictionary.asideDaysLabel}
                </span>
                <SanitizeHtml
                  tag={'span'}
                  className={'b-booking-sidebar__breakdown__item__value'}
                  html={lib.formatCurrency(
                    isPrepaid().vehicleChargeCurrency,
                    isPrepaid().vehicleCharge
                  )}
                />
              </div>
              {!!isPrepaid().prepaidTaxAmount && (
                <div className="b-booking-sidebar__breakdown__item">
                  <span className="b-booking-sidebar__breakdown__item__label">
                    {dictionary.asideTaxesFeesLabel}
                  </span>
                  <SanitizeHtml
                    tag={'span'}
                    className={'b-booking-sidebar__breakdown__item__value'}
                    html={lib.formatCurrency(
                      isPrepaid().prepaidTaxCurrency,
                      isPrepaid().prepaidTaxAmount
                    )}
                  />
                </div>
              )}
            </div>
          </div>

          {selectedExtrasPrepaid().length > 0 && (
            <>
              <div className="b-booking-sidebar__divider--dashed"></div>
              <div className="b-booking-sidebar__billing__extras">
                <div className="b-booking-sidebar__extras__title">
                  {dictionary.asideExtrasLabel}
                  {step === pageNumber.payment && isBooking && (
                    <div
                      className="b-booking-sidebar__extras__title__btn"
                      onClick={handleEditExtras}>
                      {dictionary.asideChangeExtrasLabel}
                    </div>
                  )}
                </div>
                <div className="b-booking-sidebar__extras__list">
                  {selectedExtrasPrepaid().map((extra, index) => (
                    <div
                      className="b-booking-sidebar__extras__item"
                      key={index}>
                      <span className="b-booking-sidebar__extras__item__label">
                        {extra.name}
                        {extra.requestedQuantity > 1 &&
                          ` (x${extra.requestedQuantity})`}
                      </span>
                      <SanitizeHtml
                        tag={'span'}
                        className={'b-booking-sidebar__extras__item__value'}
                        html={lib.formatCurrency(
                          extra.currency,
                          extra.totalCost
                        )}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}

          {showMilesNBonusReedeemStatus() && (
            <>
              <div className="b-booking-sidebar__divider--dashed"></div>
              <div className="b-booking-sidebar__miles-n-bonus">
                <div className="b-booking-sidebar__miles-n-bonus__label">
                  {dictionary.asideMilesNCashRedemptionLabel}
                </div>
                <div className="b-booking-sidebar__miles-n-bonus__value">
                  <div className="b-booking-sidebar__miles-n-bonus__value__cost">
                    -{milesReedemed()}
                  </div>
                  <div>
                    <span className="b-booking-sidebar__miles-n-bonus__value__miles">
                      ({mbData.redeemAmount.toLocaleString(window.lang)}{' '}
                      {dictionary.asideMilesNCashMilesLabel})
                    </span>
                  </div>
                </div>
              </div>
            </>
          )}

          <div className="b-booking-sidebar__divider--dashed"></div>

          <div
            className={`b-booking-sidebar__billing__total ${
              showMilesNBonusReedeemStatus() ? 'align-items-start' : ''
            }`}>
            <div className="b-booking-sidebar__billing__total__label">
              {hasGrandTotal && <i className="icon-payment"></i>}
              <span>
                {dictionary.asideCostTotal}
                {hasGrandTotal && (
                  <small> {dictionary.asideCostTotalPrepaid}</small>
                )}
              </span>
            </div>
            {!showMilesNBonusReedeemStatus() && (
              <span className="b-booking-sidebar__billing__total__value">
                {lib.formatCurrency(
                  hasGrandTotal
                    ? isPrepaid().prepaidCurrency
                    : isPrepaid().estimatedTotalCurrency,
                  hasGrandTotal
                    ? isPrepaid().prepaidCharge
                    : isPrepaid().estimatedTotal
                )}
              </span>
            )}
            {showMilesNBonusReedeemStatus() && (
              <div className="b-booking-sidebar__billing__total__value d-flex flex-column align-items-end">
                <span>
                  {mbData.redeemAmount.toLocaleString(window.lang)}{' '}
                  {dictionary.asideMilesNCashMilesLabel}
                </span>
                <span>
                  +{' '}
                  {lib.formatCurrency(
                    isPrepaid().prepaidCurrency,
                    isPrepaid().prepaidCharge -
                      mbData.redeemAmount / milesNBonusAccount?.rate
                  )}
                </span>
              </div>
            )}
          </div>

          {hasGrandTotal && (
            <div className="b-booking-sidebar__divider--inner"></div>
          )}

          {window.modifyData && (
            <>
              <div className="b-booking-sidebar__modification">
                {modifiedPrices?.initialPaymentWithCard > 0 && (
                  <div className="b-booking-sidebar__modification__item">
                    <span className="b-booking-sidebar__modification__item__label">
                      {dictionary.initialPaymentWithCard}
                    </span>

                    <SanitizeHtml
                      tag={'span'}
                      className={'b-booking-sidebar__modification__item__value'}
                      html={lib.formatCurrency(
                        isPrepaid().prepaidCurrency,
                        modifiedPrices?.initialPaymentWithCard
                      )}
                    />
                  </div>
                )}
                {modifiedPrices?.initialPaymentWithMiles > 0 && (
                  <div className="b-booking-sidebar__modification__item">
                    <span className="b-booking-sidebar__modification__item__label">
                      {dictionary.initialPaymentWithMiles}
                    </span>

                    <SanitizeHtml
                      tag={'span'}
                      className={'b-booking-sidebar__modification__item__value'}
                      html={lib.formatCurrency(
                        isPrepaid().prepaidCurrency,
                        modifiedPrices?.initialPaymentWithMiles
                      )}
                    />
                  </div>
                )}
                {remainingCardPayment() > 0 &&
                  step === modifyPageNumber.acceptModification && (
                    <div className="b-booking-sidebar__modification__item">
                      <span className="b-booking-sidebar__modification__item__label">
                        {dictionary.restToBePaidWithCard}
                      </span>

                      <SanitizeHtml
                        tag={'span'}
                        className={
                          'b-booking-sidebar__modification__item__value'
                        }
                        html={lib.formatCurrency(
                          isPrepaid().prepaidCurrency,
                          remainingCardPayment()
                        )}
                      />
                    </div>
                  )}
                {redeemedMilesToPrice() > 0 &&
                  step === modifyPageNumber.acceptModification && (
                    <div className="b-booking-sidebar__modification__item">
                      <span className="b-booking-sidebar__modification__item__label">
                        {dictionary.newAmountPaidWithMiles}
                      </span>

                      <SanitizeHtml
                        tag={'span'}
                        className={
                          'b-booking-sidebar__modification__item__value'
                        }
                        html={lib.formatCurrency(
                          isPrepaid().prepaidCurrency,
                          redeemedMilesToPrice()
                        )}
                      />
                    </div>
                  )}
              </div>
              <div className="b-booking-sidebar__divider--inner"></div>
            </>
          )}
        </div>
      )}

      {/* Pay on pick-up */}
      {!!isPrepaid()?.returnCharge && (
        <div className="b-booking-sidebar__billing">
          <div className="b-booking-sidebar__billing__breakdown">
            <div className="b-booking-sidebar__breakdown__title">
              {dictionary.asidePayOnPickUp}
            </div>
            <div className="b-booking-sidebar__breakdown__list">
              {!hasGrandTotal && (
                <div className="b-booking-sidebar__breakdown__item">
                  <span className="b-booking-sidebar__breakdown__item__label">
                    {dictionary.asideCarRentalLabel} {'x'}{' '}
                    {selectedVehicle.duration} {dictionary.asideDaysLabel}
                  </span>
                  <SanitizeHtml
                    tag={'span'}
                    className={'b-booking-sidebar__breakdown__item__value'}
                    html={lib.formatCurrency(
                      isPrepaid().vehicleChargeCurrency,
                      isPrepaid().vehicleCharge
                    )}
                  />
                </div>
              )}
              {!!isPrepaid()?.returnTaxAmount && (
                <div className="b-booking-sidebar__breakdown__item">
                  <span className="b-booking-sidebar__breakdown__item__label">
                    {dictionary.asideTaxesFeesLabel}
                  </span>
                  <SanitizeHtml
                    tag={'span'}
                    className={'b-booking-sidebar__breakdown__item__value'}
                    html={lib.formatCurrency(
                      isPrepaid().returnTaxCurrency,
                      isPrepaid().returnTaxAmount
                    )}
                  />
                </div>
              )}
            </div>
          </div>

          {selectedExtrasReturn().length > 0 && (
            <>
              <div className="b-booking-sidebar__divider--dashed"></div>
              <div className="b-booking-sidebar__billing__extras">
                <div className="b-booking-sidebar__extras__title">
                  {dictionary.asideExtrasLabel}

                  {step === pageNumber.payment && isBooking && (
                    <div
                      className="b-booking-sidebar__extras__title__btn"
                      onClick={handleEditExtras}>
                      {dictionary.asideChangeExtrasLabel}
                    </div>
                  )}
                </div>
                <div className="b-booking-sidebar__extras__list">
                  {selectedExtrasReturn().map((extra, index) => (
                    <div
                      className="b-booking-sidebar__extras__item"
                      key={index}>
                      <span className="b-booking-sidebar__extras__item__label">
                        {extra.name}
                        {extra.requestedQuantity > 1 &&
                          ` (x${extra.requestedQuantity})`}
                      </span>
                      <SanitizeHtml
                        tag={'span'}
                        className={'b-booking-sidebar__extras__item__value'}
                        html={lib.formatCurrency(
                          extra.currency,
                          extra.totalCost
                        )}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}

          <div className="b-booking-sidebar__divider--dashed"></div>

          <div className="b-booking-sidebar__billing__total">
            <div className="b-booking-sidebar__billing__total__label">
              {hasGrandTotal && <i className="icon-payment"></i>}
              <span>
                {dictionary.asideCostTotal}
                {hasGrandTotal && (
                  <small> {dictionary.asideCostTotalPayOnReturn}</small>
                )}
              </span>
            </div>
            <SanitizeHtml
              tag={'span'}
              className="b-booking-sidebar__billing__total__value"
              html={lib.formatCurrency(
                hasGrandTotal
                  ? isPrepaid().returnCurrency
                  : isPrepaid().estimatedTotalCurrency,
                hasGrandTotal
                  ? isPrepaid().returnCharge
                  : isPrepaid().estimatedTotal
              )}
            />
          </div>

          {hasGrandTotal && (
            <div className="b-booking-sidebar__divider--inner"></div>
          )}
        </div>
      )}

      {/* Grand Total show if both pay on pick-up and online */}
      {hasGrandTotal && (
        <div className="b-booking-sidebar__grand-total">
          <span className="b-booking-sidebar__grand-total__label">
            {dictionary.asideCostGrandTotal}
          </span>
          <SanitizeHtml
            tag={'span'}
            className="b-booking-sidebar__grand-total__value"
            html={lib.formatCurrency(
              isPrepaid().estimatedTotalCurrency,
              isPrepaid().estimatedTotal
            )}
          />
        </div>
      )}
    </>
  )
}

export default SidebarCosts
